import script from "./Reviews.vue?vue&type=script&setup=true&lang=js"
export * from "./Reviews.vue?vue&type=script&setup=true&lang=js"

import "./Reviews.vue?vue&type=style&index=0&id=1b230562&lang=css"

const __exports__ = script;

export default __exports__